import { useAuth } from 'react-oidc-context';
import { Button } from 'semantic-ui-react';
import React from 'react';
/**
 * Renders a button for logging in via Keycloak
 */
export function SignInButton({ className }) {
  const auth = useAuth();

  const handleLogin = () => {
    auth.signinRedirect({
      extraQueryParams: { prompt: 'login' },
    }).catch(console.error);
  };

  return (
    <Button className={className} onClick={handleLogin}>
      <i className="sign in icon icon-inline" />
      Please sign in
    </Button>
  );
}
